/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Box, Stack, rem, useMantineTheme, type BoxProps } from '@mantine/core';
import { Suspense, type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { useBackgroundColor } from '@fai/util/react-hooks';

export default function DEProjectSubLayout({
  headerSlot,
  tabSlot,
}: {
  headerSlot: ReactNode;
  tabSlot: ReactNode;
}) {
  const theme = useMantineTheme();

  useBackgroundColor(theme.pf.color.bg.neutral.subtle.base);

  return (
    <>
      <Box
        bg={theme.pf.color.fg.white}
        pt={theme.pf.layout.xl}
        px={{ base: theme.pf.layout.xs, lg: theme.pf.layout.md }}
        style={{
          borderBottom: `${rem(1)} solid ${theme.pf.color.border.neutral.default}`,
        }}
      >
        <Stack gap={theme.pf.layout['3xs']} {...centeredBoxProps}>
          {headerSlot}
          {tabSlot}
        </Stack>
      </Box>

      <Box
        pb={theme.pf.layout.xl}
        pt={theme.pf.layout.md}
        px={{ base: theme.pf.layout.xs, lg: theme.pf.layout.md }}
      >
        <Box {...centeredBoxProps}>
          <Suspense>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </>
  );
}

DEProjectSubLayout.displayName = 'DEProjectSubLayout';

// TODO: it can be relocated in upper directory.
const centeredBoxProps: Partial<BoxProps> = {
  m: '0 auto',
  maw: rem(1240),
  w: '100%',
};
